import React, { useState } from "react";
import { View } from "react-native";

import { buttonStyle } from "../common/ActionsMenuButton/utils";
import ActionButton from "../common/ActionsMenuButton/ActionButton";
import AskUsIcon from "../common/ActionsMenuButton/icons/AskUsIcon";
import { getContactMailUrl, openURL } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function ElementsViewFabButton({ mariOptions }) {
  const [actionButton, setActionButton] = useState(null);

  return (
    <View
      style={buttonStyle}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"EditReportElementsViewFabButton"}
      >
        <ActionButton.Item
          underline
          noBorder
          hideShadow
          buttonColor="#FFF"
          title="Help"
          onPress={() => {
            openURL(getContactMailUrl());
          }}
        >
          <AskUsIcon />
        </ActionButton.Item>
      </ActionButton>
    </View>
  );
}
